import { h, Component } from 'preact';
import linkState from 'linkstate';
const initialState = {
    price: "0",
    qty: "",
    desc: ""
};
class InvoiceInput extends Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({}, initialState, this.props.initialState);
        this.handleClick = this.handleClick.bind(this);
        this.handlePrice = this.handlePrice.bind(this);
        this.handleQty = this.handleQty.bind(this);
    }
    handleClick() {
        this.props.onClick(this.state);
    }
    handleQty(e) {
        this.setState({ qty: e.target.value });
        this.props.onPrice();
    }
    handlePrice(e) {
        this.setState({ price: e.target.value });
        this.props.onPrice();
    }
    render() {
        const isRequired = this.props.key === 0 ? { 'required': 'required' } : {};
        return h("div", { className: "row" },
            h("div", { className: "col-md-7" },
                h("div", { className: "input__row" },
                    h("label", { htmlFor: "description" }, "Description"),
                    h("textarea", { rows: "5", cols: "20", name: "desc[]", placeholder: "Description", onInput: linkState(this, "desc"), value: this.state.desc, ...isRequired }, "Description"))),
            h("div", { className: "col-md-1" },
                h("div", { className: "input__row" },
                    h("label", { htmlFor: "qty" }, "Qty"),
                    h("input", { type: "text", name: "qty[]", placeholder: "Qty", onInput: this.handleQty, value: this.state.qty }))),
            h("div", { className: "col-md-3" },
                h("div", { className: "input__row" },
                    h("label", { htmlFor: "price" }, "Price"),
                    h("input", { type: "text", name: "price[]", placeholder: "Price", onInput: this.handlePrice, value: this.state.price }))),
            h("div", { className: "col-md-1" },
                h("div", { className: "input__row" }, this.props.showBtn ? h("a", { className: "btn invoice__add-btn", onClick: this.handleClick }, "+") : null)));
    }
}
InvoiceInput.defaultProps = {
    initialState,
    showBtn: true
};
export default InvoiceInput;
